/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {
    console.log('Cart init called');
    this.$section = $section;

    // Remove any existing click handlers first
    $(document).off('click', '.cart__remove-btn, .ajax-cart__delete, [data-cart-page-delete]');
    console.log('Removed existing click handlers');

    // Add new click handler targeting all possible selectors
    $(document).on('click', '.cart__remove-btn, .ajax-cart__delete, [data-cart-page-delete]', function (e) {
      console.log('Remove button clicked');
      console.log('Button classes:', this.className);
      console.log('Button data attributes:', $(this).data());
      
      e.preventDefault();
      e.stopPropagation();
      
      const lineID = $(this).data('line-item-key');
      console.log('Line ID:', lineID);
      
      if (!lineID) {
        console.error('No line ID found');
        return false;
      }

      const $cartItem = $(this).closest('[data-line-item]');
      console.log('Cart item element:', $cartItem);
      
      // Create and submit a form to remove the item
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/change';
      
      const lineInput = document.createElement('input');
      lineInput.type = 'hidden';
      lineInput.name = 'line';
      lineInput.value = lineID;
      
      const quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '0';
      
      form.appendChild(lineInput);
      form.appendChild(quantityInput);
      document.body.appendChild(form);
      
      console.log('Form created and appended to body');
      console.log('Form action:', form.action);
      console.log('Form data:', {
        line: lineID,
        quantity: '0'
      });
      
      // Submit the form
      console.log('Submitting form...');
      form.submit();
      
      return false;
    });

    // Handle quantity changes
    $(document).on('change', '.quantity-input', function() {
      console.log('Quantity changed');
      const lineID = $(this).closest('[data-line-item-key]').data('line-item-key');
      const quantity = $(this).val();
      console.log('Line ID:', lineID, 'New quantity:', quantity);

      // Create and submit a form to update quantity
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/change';
      
      const lineInput = document.createElement('input');
      lineInput.type = 'hidden';
      lineInput.name = 'line';
      lineInput.value = lineID;
      
      const quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = quantity;
      
      form.appendChild(lineInput);
      form.appendChild(quantityInput);
      document.body.appendChild(form);
      
      console.log('Submitting quantity change form...');
      form.submit();
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    console.log('removeFromCart called with lineID:', lineID);
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);
    console.log('Found cart item:', $cartItem);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        console.log('AJAX success, cart data:', cart);
        if(tbnp_glbl_values) {
          var item = tbnp_glbl_values._cart.items[lineID - 1];
          if(item) {
            console.log('Item found in tbnp_glbl_values:', item);
            gtag("event", "remove_from_cart", {
              currency: "PHP",
              items: [
                {
                  item_id: item.product_id.toString(),
                  item_name: item.product_title,
                  currency: 'PHP',
                  item_brand: item.vendor,
                  item_category: item.product_type,
                  item_variant: item.variant_title,
                  price: (item.final_line_price * 0.01).toFixed(2),
                  quantity: item.quantity
                }
              ]
            });
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
              event: 'removeFromCart',
              ecommerce: {
                remove: {
                  products: [{
                      name: item.product_title,
                      id: item.product_id.toString(),
                      price: (parseInt(item.final_line_price) / 100).toFixed(2),
                      brand: item.vendor,
                      category: item.product_type,
                      variant: item.variant_title,
                      quantity: item.quantity
                  }]
                }
              }
            });
          }
        }

        console.log('Attempting to reload page...');
        window.location.href = window.location.href;
      },
      error: function (XMLHttpRequest, textStatus) {
        console.error('AJAX error:', textStatus);
        console.error('Response:', XMLHttpRequest.responseText);
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        window.location.href = window.location.href;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('.cart__remove-btn, .ajax-cart__delete, [data-cart-page-delete]').off();
    $('.quantity-input').off();
    $('#cart_form').off();
  }
}

// Initialize cart immediately when the script loads
$(document).ready(function() {
  Shopify.theme.jsCart.init($('[data-section-type="cart"]'));
});

// Also try to initialize on section load
$(document).on('shopify:section:load', function(event) {
  console.log('Section load - initializing cart');
  if ($(event.target).is('[data-section-type="cart"]')) {
    Shopify.theme.jsCart.init($(event.target));
  }
});

/******/ })()
;